import type { SearchItemsData } from '@metto/http-clients/api';

export const Sources = ['bookmarks', 'notes', 'images', 'trash'] as const;
export type Source = (typeof Sources)[number];

export const Filters = ['favorites', 'untagged'] as const;
export type Filter = (typeof Filters)[number];

export type SearchToken =
  | { type: 'text'; value: string }
  | { type: 'tag'; fullName: string; id?: string }
  | { type: 'source'; value: Source }
  | { type: 'filter'; value: Filter };

export type SearchQuery = SearchItemsData['query'];

export const EmptySearchQuery: SearchQuery = {
  q: '',
  sources: [],
  filters: [],
  tagIds: []
};
